<!-- 首页 -->
<template>
  <div :class="{'home-box':true,'fixed':show}">
    <div class="home-container">
      <!-- 标题 -->
      <div class="tuijian">
        <div :class="{'tj-item':true,'choose':tab}" @click="tabItem(0)">推荐企业</div>
        <div :class="{'tj-item':true,'choose':!tab}" @click="tabItem(1)">职位推荐</div>
      </div>
      <!-- 搜索 -->
      <van-search placeholder="请输入搜索关键词" disabled @click="nav(0)" />
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.path" class="banner" />
        </van-swipe-item>
      </van-swipe>

      <!-- 筛选 推荐-->
      <div class="home-tuijian" v-show="!tab">
        <div class="home-text">
          <div class="home-tj" @click="tabItem(2)">
            推荐
            <div :class="{'home-zx':true,'color':tabs}"></div>
          </div>
          <div class="home-tj" @click="tabItem(3)">
            最新
            <div :class="{'home-zx':true,'color':!tabs}"></div>
          </div>
        </div>
        <div class="home-address">
          <div :class="{'home-items':true,' actived':selectInfo.length>0}" @click="nav(1)">
            <span
              :class="{'actived':selectInfo.length>0}"
            >{{selectInfo.length==0?'地点':selectInfo[0]}}</span>
            <img
              :src="selectInfo.length==0?require('@/assets/img/home/selectDown.png'):require('@/assets/img/home/selected.png')"
            />
          </div>
          <div :class="{'home-items':true,' actived':selectNums!=''}" @click="nav(2)">
            <span :class="{'actived':selectNums!=''}">{{selectNums==''?'筛选':'筛选·'+selectNums}}</span>
            <img
              :src="selectNums==''?require('@/assets/img/home/selectDown.png'):require('@/assets/img/home/selected.png')"
            />
            <!-- 选中
            <img src="../assets/img/home/selected.png" />-->
          </div>
        </div>
      </div>
      <div style="position:relative;margin-top:0.3rem" v-show="tab">
        <van-tabs
          v-model="activeName"
          @click="choosed"
          title-active-color="#ff4343"
          v-if="tab"
          sticky
          :ellipsis="false"
        >
          <van-tab
            :title="item.name"
            :name="item.category_id"
            v-for="(item, index) in tablist"
            :key="index"
          ></van-tab>
        </van-tabs>
        <div class="items" @click="show=!show">
          <van-icon name="wap-nav" size="25" color="#ff4343" />
        </div>
      </div>
    </div>
    <!-- 筛选 企业 -->

    <div class="box">
      <div class="home-tab" v-show="tab">
        <div v-if="tab">
          <!-- 列表项 -->
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              :immediate-check="false"
            >
              <!-- 推荐企业 -->

              <div
                class="company-list"
                v-for="(item, index) in positionList"
                :key="index"
                @click="navDetails(item.company_id)"
              >
                <img class="company-img" :src="item.logo" />
                <div class="company-box">
                  <span class="name">{{item.name}}</span>
                  <div class="icon">
                    <span class="item">{{item.address}} ∣ {{item.nature_name}} ∣ {{item.trade_name}}</span>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <van-overlay :show="show" @click="show=false" />
        <div
          :class="{'tab-box':true,'tab-content':!show,'transition':show}"
          :style="{'padding':show?'':'0%'}"
        >
          <div
            :class="{'tab-item':true, 'tab-choose':category_id==item.category_id}"
            v-show="show"
            v-for="(item,index) in tablist"
            :key="index"
            @click="choosed(item.category_id,index)"
          >{{item.name}}</div>
        </div>
      </div>
    </div>
    <div v-if="!tab" style="padding-top:0.45rem">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <div
            class="list"
            v-for="(item, index) in positionList"
            :key="index"
            @click="goDetails(item.job_id)"
          >
            <div class="list-item">
              <span class="list-title">{{item.job_name}}</span>
              <span
                class="list-price"
              >{{item.salary_type==0?item.min_salary==item.max_salary?item.max_salary:`${item.min_salary}-${item.max_salary}`:'面议'}}</span>
            </div>
            <div class="list-item">
              <span class="list-request">{{item.district_name}}</span>
              <span class="list-request">{{item.experience==0?'不限':item.experience}}</span>
              <span class="list-request">{{item.education==0?'不限':item.education}}</span>
              <span class="list-request">{{item.amount==0?'不限':`招${item.amount}人`}}</span>
            </div>
            <div class="list-item">
              {{item.tag.length==0?'还没有添加福利哦~':''}}
              <span
                class="list-welfare"
                v-for="(i, idx) in item.tag"
                :key="idx"
              >{{i}}</span>
            </div>
            <div class="list-item">
              <img :src="item.company_logo" class="list-logo" />
              <span class="list-name">{{item.company_name}}</span>
              <button class="list-btn">申请</button>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="zhuce" @click="zhuce">
      <img src="@/assets/img/home/zhuce.png" />
    </div>
    <div class="backs" @click="back">
      <img src="@/assets/img/home/toBack.png" />
    </div>

    <!-- 弹窗 -->
    <van-popup v-model="shows" round>
      <div class="overly">
        <div class="type">选择账号注册类型</div>
        <div class="item" @click="navRegister(2)">个人注册</div>
        <div class="item" @click="navRegister(1)">企业注册</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { mapState, mapMutations } from "vuex";
import {
  getPositionList,
  getBanner,
  companyQuery,
  getKindArray
} from "@/api/apiData";
export default {
  // inject: ['Token'],
  name: "home",
  data() {
    return {
      activeName: "",
      page: 0,
      totalPages: 1,
      positionList: [],
      offset: 10,
      loading: false,
      finished: false,
      refreshing: false,
      bannerList: [],
      shows: false,
      tab: true,
      tabs: true,
      idx: "index",
      show: false,
      tablist: [],
      category_id: "",
      is_recommend: 1,
      is_latest: 1
    };
  },
  computed: {
    ...mapState(["list", "token", "selectNums", "selectInfo"])
  },

  watch: {
    selectInfo(newVal, old) {
      const that = this;
      that.tab = false;
      that.positionList = [];
      that.totalPages = 1;
      that.page = 0;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.getList();
    },
    list() {
      const that = this;
      that.tab = false;
      that.positionList = [];
      that.totalPages = 1;
      that.page = 0;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.getList();
    }
  },
  methods: {
    ...mapMutations([
      "select",
      "selectNum",
      "selectAddress",
      "keepAliveRouter"
    ]),
    // 获取行业
    getTrade() {
      getKindArray({ key: "trade" }).then(res => {
        //(res);
        let info = { category_id: "", name: "全部" };
        res.data.unshift(info);
        this.tablist = res.data;
      });
    },
    // 推荐切换
    tabItem(val) {
      const that = this;
      that.toggle = val;
      that.positionList = [];
      that.totalPages = 1;
      that.page = 0;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      switch (val) {
        case 0: //推荐企业
          that.tab = true;
          that.getList();
          break;
        case 1: //职位推荐
          that.tab = false;
          that.getList();
          break;
        case 2: //推荐
          that.tabs = true;
          that.is_latest = "";
          that.is_is_recommend = 1;
          that.getList();
          break;
        case 3: //最新
          that.tabs = false;
          that.is_latest = 1;
          that.is_recommend = "";
          that.getList();
          break;
      }
    },
    // 查看公司详情
    navDetails(id) {
      const that = this;
      that.$router.push({
        name: "ComponyDetails",
        query: {
          id: id
        }
      });
    },
    // 企业筛选
    choosed(val, index) {
      const that = this;
      // that.idx = index;
      that.activeName = val;
      that.category_id = val;
      that.page = 0;
      that.positionList = [];
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getList();
      setTimeout(() => {
        that.show = false;
      }, 100);
    },
    // 遮罩层关闭
    // overlay() {
    //   const that = this;
    //   that.show;
    // },
    // 上拉加载
    onLoad() {
      this.getList();
    },
    back() {
      this.$router.back();
    },
    // 注册
    zhuce() {
      const that = this;
      that.shows = true;
    },
    navRegister(val) {
      if (val == 1) {
        this.show = false;
        if (this.keepAliveRoute != 1) {
          this.keepAliveRouter("1");
        }
        setTimeout(() => {
          this.keepAliveRouter("compny,indexs");
        }, 200);
        this.$router.push({
          name: "Register"
        });
      } else {
        this.show = false;
        if (this.keepAliveRoute != 1) {
          this.keepAliveRouter("1");
        }
        setTimeout(() => {
          this.keepAliveRouter("register,soliderInfo");
        }, 200);
        this.$router.push({
          name: "userRegister"
        });
      }
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.page = 0;
      that.category_id = "";
      that.activeName = "";
      that.positionList = [];
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      if (that.list.length > 0) {
        that.select(["", "", "", 0]);
      }
      that.selectNum("");
      if (that.selectInfo.length > 0) {
        that.selectAddress(["", "", 0, "type"]);
      }
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 2000);
    },
    // 获取首页轮播图
    getBannerList() {
      var that = this;
      getBanner().then(res => {
        if (res.code == 1) {
          that.bannerList = res.data;
        }
      });
    },
    // 路由跳转
    nav(val) {
      var that = this;
      const tab=that.tab
      if (val == 0) {
        // 搜索
        that.$router.push({
          path:'/home/search',
          query:{
            type:tab
          }
        });
      } else if (val == 1) {
        // 地点
        that.$router.push({
          path: "/home/address",
          query: {
            entrance: "0"
          }
        });
      } else {
        //筛选
        that.$router.push({
          path: "/home/screen",
          query: {
            entrance: "0"
          }
        });
      }
    },
    // 前往职位详情
    goDetails(id) {
      var that = this;
      that.$router.push({
        name: "positionDetails",
        query: {
          id: id
        }
      });
    },
    // 获取职位列表
    getList() {
      var that = this;
      let {
        page,
        totalPages,
        positionList,
        offset,
        selectInfo,
        list,
        tab,
        category_id,
        is_recommend,
        is_latest
      } = that;

      if (tab) {
        let obj = {
          page: page + 1,
          offset: offset,
          is_recommend: 1,
          tarde: category_id
        };
        if (totalPages > page) {
          that.loading = true;
          companyQuery(obj).then(res => {
            // //(res);
            if (res.code == 1) {
              that.positionList = positionList.concat(res.data.data);
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.page = page + 1;
              if (res.data.length == 0) {
                setTimeout(() => {
                  that.loading = false;
                  that.finished = true;
                }, 1500);
                return false;
              }
              if (that.positionList.length > positionList.length) {
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            }
          });
        } else {
          that.finished = true;
          that.loading = false;
        }
      } else {
        //(22);
        // //(selectInfo);
        // //(list);
        let obj = {
          page: page + 1,
          offset: offset,
          is_latest: is_latest,
          is_recommend: is_recommend,
          district: selectInfo.length > 0 ? selectInfo[1] : "",
          education: list.length > 0 ? (list[0] == "-1" ? "" : list[0]) : "",
          experience: list.length > 0 ? (list[2] == "-1" ? "" : list[2]) : "",
          min_salary:
            list.length > 0 ? (list[1].length > 0 ? list[1][0] : "") : "",
          max_salary:
            list.length > 0 ? (list[1].length > 0 ? list[1][1] : "") : ""
        };
        if (totalPages > page) {
          that.loading = true;
          getPositionList(obj).then(res => {
            //(res);
            if (res.code == 1) {
              that.positionList = positionList.concat(res.data.list);
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.page = page + 1;
              if (res.data.list.length == 0) {
                setTimeout(() => {
                  that.loading = false;
                  that.finished = true;
                }, 1500);
                return false;
              }
              if (that.positionList.length > positionList.length) {
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            }
          });
        } else {
          that.finished = true;
          that.loading = false;
        }
      }
    }
  },
  created() {
    // this.Token()
  },
  mounted() {
    var that = this;
    that.getBannerList();
    that.getList();
    that.getTrade();
    that.keepAliveRouter("home");
  },
  destroyed() {
    const that = this;
    that.keepAliveRouter("1");
  }
};
</script>
<style lang='less' scoped>
.van-popup--center {
  width: 80%;
}
/deep/.van-tabs__nav {
  width: 85%;
}
/deep/.van-tab__pane {
  height: 0;
}
.fixed {
  position: fixed;
  width: 100%;
  height: 100%;
}
.home-box {
  background: #f7f7f7;

  .home-container {
    background: #fff;
    padding: 0 0.32rem;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    // 标题
    .tuijian {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.3rem;
      font-weight: 500;
      line-height: 1.5;
      color: #ff4343;
      border-radius: 0.2rem;
      border: 1px solid #ff4343;
      width: 3.4rem;
      margin: 0.3rem auto 0;
    }
    .tj-item {
      flex: 1;
      text-align: center;
    }
    .tj-item:first-child {
      border-radius: 0.15rem 0 0 0.15rem;
    }
    .tj-item:nth-child(2) {
      border-radius: 0 0.15rem 0.15rem 0;
    }
    .van-search {
      padding: 0.3rem 0;
    }
    //选中
    .choose {
      background: #ff4343;
      color: #fff;
    }
    .home-title {
      position: fixed;
      width: 100%;
      z-index: 10;
      padding: 0.18rem 0;
      top: 0;
      left: 0;
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      background: #fff;
    }
    // 轮播图
    .my-swipe {
      .van-swipe-item {
        .banner {
          width: 100%;
          height: 2.6rem;
          display: block;
          border-radius: 0.16rem;
        }
      }
    }
    // 职位推荐
    .home-tuijian {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: rgba(50, 50, 50, 1);
      margin-top: 0.18rem;
      padding: 0.15rem 0;
      .home-text {
        font-size: 0.3rem;
        font-weight: 600;
        line-height: 0.42rem;
        text-align: left;
        flex: 1;
        display: flex;
        align-items: center;
        .home-tj {
          margin-right: 0.3rem;
        }

        .home-zx {
          // content: "";
          // display: block;
          width: 100%;
          height: 0.06rem;
          background: transparent;
          margin-right: 0.1rem;
          margin-top: 0.15rem;
          border-radius: 0.03rem;
        }
        .color {
          background: #ff4343;
        }
      }

      .home-address {
        flex: 1.5;
        display: flex;
        justify-content: flex-end;
        .home-items {
          display: flex;
          align-items: center;
          padding: 0.08rem 0.15rem;
          background: rgba(247, 247, 247, 1);
          border-radius: 0.04rem;
          margin: 0 0.1rem;
          flex-wrap: wrap;
          span {
            font-size: 0.24rem;
            font-weight: 400;
            color: rgba(112, 112, 112, 1);
          }
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
        }
        .actived {
          color: #ff4343 !important;
          background: rgba(255, 238, 238, 1);
        }
      }
    }
    .items {
      position: absolute;
      right: 0;
      top: -0.35rem;
      text-align: center;
      min-width: 10%;
      z-index: 100;
    }
  }
  // 筛选 企业
  .home-tab {
    position: relative;
    font-size: 0.3rem;
    // display: flex;
    // align-items: center;
    padding: 0 0 0.05rem;
    margin-top: 0.45rem;
    font-size: 0.28rem;
    font-weight: 550;
    line-height: 1.5;
    color: #000;
    // justify-content: space-between;
    .van-overlay {
      top: 45%;
    }
    .tab-box {
      width: 110%;
      background: #fff;
      position: absolute;
      top: 1%;
      left: -5%;
      z-index: 2000;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      padding: 5% 8%;
      .tab-item {
        min-width: 40%;
        height: 0.6rem;
        text-align: center;
        line-height: 0.6rem;
        background: #fff;
        font-size: 0.28rem;
        font-weight: bold;
        color: #000;
        border-radius: 0.2rem;
        margin-bottom: 0.3rem;
        border: 1px solid #c8c8c8;
      }
      .tab-choose {
        color: #fff;
        background: #ff4343;
        border: 1px solid #ff4343;
      }
    }
    .tab-box::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }
    .tab-content {
      height: 0;
      transition: height 0.3s;
      -webkit-transition: height 0.3s;
      -moz-transition: height 0.3s;
    }

    .transition {
      height: 6rem;
      transition: height 0.3s;
      -webkit-transition: height 0.3s;
      -moz-transition: height 0.3s;
      overflow-y: scroll;
    }
    .border {
      width: 60%;
      height: 0.06rem;
      border-radius: 0.03rem;
      background: transparent;
      margin: 0.1rem auto 0;
    }
    .border-color {
      background: #ff4343;
    }
  }
  .box::before {
    content: "";
    display: block;
    width: 100%;
    height: 5.4rem;
  }

  //   列表项
  .list {
    background: #fff;
    padding: 0.24rem 0.32rem;
    margin-top: 0.2rem;
    .list-item {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      flex-wrap: wrap;
      .list-title {
        display: flex;
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 1.5;
        color: rgba(50, 50, 50, 1);
      }
      .list-price {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 1.5;
        color: rgba(255, 67, 67, 1);
        justify-items: flex-end;
      }
      .list-request {
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
      }
      .list-welfare {
        padding: 0.06rem 0.1rem;
        background: rgba(248, 248, 248, 1);
        border-radius: 0.04rem;
        color: rgba(77, 77, 77, 1);
        font-size: 0.24rem;
        margin-right: 0.16rem;
        line-height: 0.33rem;
        margin-bottom: 0.1rem;
      }
      .list-btn {
        padding: 0.09rem 0.32rem !important;
        line-height: 0.33rem;
        font-size: 0.24rem;
        color: rgba(255, 255, 255, 1);
        background: #ff4343;
        border-radius: 0.04rem;
        position: absolute;
        right: 0;
      }
      // 已申请
      .applied {
        background: rgba(204, 204, 204, 1);
      }
      .list-logo {
        width: 0.36rem;
        height: 0.36rem;
        margin-right: 0.1rem;
      }
      .list-name {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .list-request::after {
        content: "";
        display: block;
        width: 0.02rem;
        height: 0.2rem;
        background: #4d4d4d;
        margin: 0 0.2rem;
      }
      .list-request:last-child::after {
        display: none;
      }
    }
    .list-item {
      min-height: 0.3rem;
      font-size: 0.24rem;
      color: rgba(77, 77, 77, 1);
    }
    .list-item:nth-child(1) {
      justify-content: space-between;
    }
    .list-item:nth-child(2),
    .list-item:nth-child(4) {
      padding: 0.16rem 0;
    }
    // .list-item:nth-child(3) {
    //   .fl-box {

    //     max-width: 83%;
    //     display: flex;
    //     flex-wrap: wrap;
    //   }
    // }
  }
  .company-list {
    background: #fff;
    padding: 0.24rem 0.32rem;
    margin-top: 0.2rem;
    font-size: 0.3rem;
    display: flex;
    .company-img {
      width: 1.2rem;
      height: 1.2rem;
    }
    .company-box {
      margin-left: 0.3rem;
      position: relative;
      width: 80%;
      .name {
        font-size: 0.34rem;
        font-weight: bold;
        line-height: 1.5;
        color: #333333;
        display: block;
        margin-bottom: 0.14rem;
      }
      .icon {
        display: flex;
        align-items: center;
        font-size: 0.22rem;
        color: #8f8f8f;
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }
  .backs {
    position: fixed;
    bottom: 5%;
    right: 5%;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    box-shadow: 0 0 0.05rem 0.01rem rgba(21, 21, 21, 0.3);
    z-index: 2;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.5rem;
      height: 0.5rem;
    }
  }
  .zhuce {
    position: fixed;
    bottom: 15%;
    right: 5%;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    box-shadow: 0 0 0.05rem 0.01rem rgba(21, 21, 21, 0.3);
    z-index: 2;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.8rem;
      height: 0.8rem;
    }
  }
  // 弹窗
  .overly {
    background: #fff;
    width: 100%;
    font-size: 0.3rem;
    padding: 0.5rem;

    .type {
      text-align: center;
      font-weight: bold;
      font-size: 0.4rem;
      margin-bottom: 0.3rem;
    }
    .item {
      line-height: 3;
      text-align: center;
      display: block;
      color: #000;
    }
    .item:hover {
      color: burlywood;
      background: rgba(21, 21, 21, 0.1);
    }
  }
  // .list:nth-child(2) {
  //   margin-top: 0;
  // }
}
</style>